/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Loader from 'react-loader-spinner';
import Graph from '../graph/graph.jsx';
import Boxplot from '../graph/boxplot.jsx';
import Warmingstripesplot from '../graph/warmingstripesplot.jsx';
import './datawrapper.scss';
import MapChart from '../mapchart/mapchart.jsx';
import colors from '../../../../../../../../apps/baykis-pl/pattern-lab/_data/generated_colors.json';
import Table from '../table/table.jsx';
import MapChartComparison from '../mapchart/mapchartComparison.jsx';
import ComparisonTable from '../table/comparisonTable.jsx';
import {buildGeoPath, extractActiveShape, generateColorConfig,} from '../mapchart/MapUtlitiy';
import TimeMap from '../mapchart/TimeMap';
import TimeGraph from '../graph/timeGraph.jsx';
import YearsMap from '../mapchart/YearsMap';
import { getDateString } from '../../../../../../tokens/js/utils/functions';
import ExportButtons from '../exportbuttons/exportbuttons.jsx';

// TODO: remove later
const host = window.location.hostname;
const prefix =
  host.includes('patternlab') ||
  host.includes('styleguide') ||
  host === 'dev.baykis.test' ||
  (host.includes('localhost') && !host.includes('drupal'))
    ? ''
    : '/themes/baykis/dist/app-drupal';

const colorSetsFutureURL = `${prefix}/assets/statics/data/colorsetsFuture.json`;
const colorSetsPastURL = `${prefix}/assets/statics/data/colorsetsPast.json`;
const colorSetsFutureDiff = `${prefix}/assets/statics/data/colorsetsFutureDiff.json`;
const lonlatURL = `${prefix}/assets/statics/data/Cells-lon_lat.json`;
const START_YEAR = 1985;
const END_YEAR = 2085;
const BETWEEN_YEAR_1 = 2019;
const BETWEEN_YEAR_2 = 2020;

const rcpLables = {
  rcp26: 'RCP 2.6',
  rcp45: 'RCP 4.5',
  rcp85: 'RCP 8.5',
};
let freshData = false;
let actuallyLoading = false;
let colorsSetsTemp;

  class Datawrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      colorsets: [],
      colorsetsComparison: [],
      colorsetsTimeMap: [],
      mapData: [],
      mapDataYears: [],
      latLonData: [],
      graphData: [],
      graphDataTime: [],
      timeGraphLimits: { min: 0, max: 0 },
      refPeriod: [],
      diffDataFirstMap: [],
      diffDataSecondMap: [],
      diffDataComparison: [],
      dataTimeMaps: [],
      tableCaption: '',
      tableData: [],
      differenceMapToRefPeriod: [],
      selectedChangesAddedToRefperiod: [],
    };
    this.placeholderMap = React.createRef();
  }

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    freshData =  false;
    const {apiParameter, mode} = this.props;
    if (prevProps.apiParameter !== apiParameter || prevProps.mode !== mode) {
      this.getData();
    }
  }

  getData = () => {
    // this.setState({ freshData: false });
    freshData = false;

    const { mode, vistype } = this.props;

    if (mode === 'warmingstripes') {
      this.getWarmingStripes();
    } else if (this.props.epoch === 'past') {
      if (mode === 'years') {
        this.getPastYears();
      } else {
        this.getPast();
      }
    } else if (mode === 'scenarios' && vistype === 'map') {
      this.getFutureComparison();
    } else if (mode === 'time' && vistype === 'map') {
      this.getFutureTimeMaps();
    } else if (mode === 'time' && vistype === 'chart') {
      this.getFutureTimeGraph();
    } else {
      this.getFuture();
    }
  };

  getPast() {
    const promises = [];
    const files = [colorSetsPastURL, lonlatURL];
    this.setState({ isLoading: true });
    freshData = false;
    const {
      vistype,
      apiEndpoint,
      apiParameter,
      selectedYear,
      regionName,
      regionPartitioning,
    } = this.props;

    files.push(
      `${apiEndpoint}ref-period/RefPeriod_${apiParameter[0]}/${apiParameter[4]}`
    );
    if (vistype === 'map') {
      files.push(
        `${apiEndpoint}shape/current_${apiParameter[0]}/${apiParameter[4]}/${selectedYear}`,
        `${apiEndpoint}diff/past/${apiParameter[0]}/${apiParameter[4]}/${selectedYear}`
      );

      files.forEach((url) => {
        promises.push(
          fetch(url, {
            method: 'get',
          })
            .then((response) => response.json())
            .then((response) => response)
        );
      });
      Promise.all(promises).then((values) => {
        const useColors = values[0].colorsets.filter(
          (obj) => obj.var === apiParameter[0]
        );
        if (useColors.length === 0) {
          // [useColors] = colorsets;
          console.log('No matching colorset found');
        }
        freshData = true;
        this.setState({
          isLoading: false,
          // freshData: true,
          colorsets: useColors,
          latLonData: values[1],
          refPeriod: values[2],
          mapData: values[3],
          differenceMapToRefPeriod: values[4],
          chartSubtitle: this.getRegionLabel(regionName, regionPartitioning),
        });
      });
    } else {
      files.push(
        `${apiEndpoint}cluster/current_${apiParameter[0]}/${apiParameter[4]}/1951/2019`
      );
      files.forEach((url) => {
        promises.push(
          fetch(url, {
            method: 'get',
          })
            .then((response) => response.json())
            .then((response) => response)
        );
      });
      Promise.all(promises).then((values) => {
        const useColors = values[0].colorsets.filter(
          (obj) => obj.var === apiParameter[0]
        );
        if (useColors.length === 0) {
          console.log('ERROR: No matching colorset found');
        }

        this.setState({
          isLoading: false,
          colorsets: useColors,
          latLonData: values[1],
          refPeriod: values[2],
          graphData: values[3],
          chartSubtitle: this.getRegionLabel(regionName, regionPartitioning),
        });
      });
    }
  }

  getPastYears() {
    const promises = [];
    const files = [colorSetsPastURL, lonlatURL];
    this.setState({isLoading: true});
    actuallyLoading = true;
    freshData = false;
    const {
      apiEndpoint,
      apiParameter,
      selectedYear,
      regionName,
      regionPartitioning,
    } = this.props;
    const years = apiParameter[5];

    years.forEach((year) => {
      files.push(
        `${apiEndpoint}diff/past/${apiParameter[0]}/${apiParameter[4]}/${year.value}`
      );
    });


    files.forEach((url) => {
      promises.push(
        fetch(url, {
          method: 'get',
        })
          .then((response) => response.json())
          .then((response) => response)
      );
    });
    Promise.all(promises).then((values) => {
      const useColors = values[0].colorsets.filter(
        (obj) => obj.var === apiParameter[0]
      );
      if (useColors.length === 0) {
        console.log('No matching colorset found');
      }
      const mapData = [];
      years.forEach((year, index) => {
        mapData.push(values[2 + index]);
      });

      freshData = true;
      actuallyLoading = false;
      this.setState({
        isLoading: false,
        // freshData: true,
        colorsets: useColors,
        latLonData: values[1],
        mapDataYears: mapData,
        chartSubtitle: `${this.getRegionLabel(regionName, regionPartitioning)},  Differenz zur Referenzperiode`,
      });
    });
  }

  getFuture() {
    const promises = [];
    const files = [colorSetsFutureURL, lonlatURL];
    this.setState({ isLoading: true });
    actuallyLoading = true;
    const {
      vistype,
      apiEndpoint,
      apiParameter,
      calledRCP,
      regionName,
      regionPartitioning,
      chartTitle,
    } = this.props;

    files.push(
      `${apiEndpoint}ref-period/RefPeriod_${apiParameter[0]}/${apiParameter[4]}`
    );
    if (vistype === 'map') {
      files.push(
        `${apiEndpoint}shape/${apiParameter[1]}_${apiParameter[0]}-${apiParameter[2]}/${apiParameter[4]}/${apiParameter[3]}`,
        `${apiEndpoint}cluster/current_${apiParameter[0]}/${apiParameter[4]}/1971/2000`,
        `${apiEndpoint}cluster/${calledRCP}_${apiParameter[0]}/${apiParameter[4]}/2035`,
        `${apiEndpoint}cluster/${calledRCP}_${apiParameter[0]}/${apiParameter[4]}/2055`,
        `${apiEndpoint}cluster/${calledRCP}_${apiParameter[0]}/${apiParameter[4]}/${END_YEAR}`,
        `${apiEndpoint}diff/future/${apiParameter[1]}/${apiParameter[0]}/${apiParameter[2]}/${apiParameter[4]}/${apiParameter[3]}`
      );

      files.forEach((url) => {
        promises.push(
          fetch(url, {
            method: 'get',
          })
            .then((response) => response.json())
            .then((response) => response)
        );
      });
      Promise.all(promises).then((values) => {
        const useColors = values[0].colorsets.filter(
          (obj) => obj.var === apiParameter[0]
        );
        if (useColors.length === 0) {
          // [useColors] = colorsets;
          console.log('No matching colorset found');
        }
        let rcp = '';
        switch (calledRCP) {
          case 'rcp26':
            rcp = 'RCP 2.6';
            break;

          case 'rcp45':
            rcp = 'RCP 4.5';
            break;

          default:
            rcp = 'RCP 8.5';
            break;
        }

        const avg = {};

        avg.value =
          values[4].reduce((sum, val) => sum + val.value, 0) / values[4].length;

        actuallyLoading = false;
        this.setState({
          isLoading: false,
          colorsets: useColors,
          latLonData: values[1],
          refPeriod: values[2],
          mapData: values[3],
          selectedChangesAddedToRefperiod: values[8],
          tableCaption: `Änderungssignale ${chartTitle} für die Region ${regionName} des Emissionsszenarios ${rcp} im Vergleich zur Vergangenheit`,
          tableData: [
            [avg],
            values[5],
            values[6],
            values[7],
            useColors[0].changeUnit,
            useColors[0].absolutUnit,
          ],
          chartSubtitle: `${this.getRegionLabel(
            regionName,
            regionPartitioning
          )}, ${rcp}, ${this.getAggregationLabel(apiParameter[2])}`,
        });
      });
    } else {
      files.push(
        `${apiEndpoint}cluster/rcp26_${apiParameter[0]}/${apiParameter[4]}/${START_YEAR}/${BETWEEN_YEAR_1}`,
        `${apiEndpoint}cluster/rcp26_${apiParameter[0]}/${apiParameter[4]}/${BETWEEN_YEAR_2}/${END_YEAR}`,
        `${apiEndpoint}cluster/rcp45_${apiParameter[0]}/${apiParameter[4]}/${START_YEAR}/${BETWEEN_YEAR_1}`,
        `${apiEndpoint}cluster/rcp45_${apiParameter[0]}/${apiParameter[4]}/${BETWEEN_YEAR_2}/${END_YEAR}`,
        `${apiEndpoint}cluster/rcp85_${apiParameter[0]}/${apiParameter[4]}/${START_YEAR}/${BETWEEN_YEAR_1}`,
        `${apiEndpoint}cluster/rcp85_${apiParameter[0]}/${apiParameter[4]}/${BETWEEN_YEAR_2}/${END_YEAR}`
      );
      files.forEach((url) => {
        promises.push(
          fetch(url, {
            method: 'get',
          })
            .then((response) => response.json())
            .then((response) => response)
        );
      });
      Promise.all(promises).then((values) => {
        const useColors = values[0].colorsets.filter(
          (obj) => obj.var === apiParameter[0]
        );
        if (useColors.length === 0) {
          console.log('ERROR: No matching colorset found');
        }

        const valuesRcp26 =
          values[3].length > 0 && values[4].length > 0
            ? values[3].concat(values[4])
            : [];
        const valuesRcp45 =
          values[5].length > 0 && values[6].length > 0
            ? values[5].concat(values[6])
            : [];
        const valuesRcp85 =
          values[7].length > 0 && values[8].length > 0
            ? values[7].concat(values[8])
            : [];
        actuallyLoading = false;
        this.setState({
          isLoading: false,
          colorsets: useColors,
          latLonData: values[1],
          refPeriod: values[2],
          graphData: [valuesRcp26, valuesRcp45, valuesRcp85],
          chartSubtitle: this.getRegionLabel(regionName, regionPartitioning),
        });
      });
    }
  }

  getFutureComparison() {
    const promises = [];
    const files = [colorSetsFutureURL, colorSetsFutureDiff, lonlatURL];
    this.setState({ isLoading: true });
    actuallyLoading = true;
    const {
      apiEndpoint,
      apiParameter,
      calledComparisonRCP,
      regionName,
      regionPartitioning,
      chartTitle,
    } = this.props;

    const firstRCP = calledComparisonRCP.split('VS')[0];
    const secondRCP = calledComparisonRCP.split('VS')[1];

    files.push(
      // [3] first PCR data
      `${apiEndpoint}shape/${firstRCP}_${apiParameter[0]}-${apiParameter[2]}/${apiParameter[4]}/${apiParameter[3]}`,
      // [4] second PCR data
      `${apiEndpoint}shape/${secondRCP}_${apiParameter[0]}-${apiParameter[2]}/${apiParameter[4]}/${apiParameter[3]}`,
      // [5] comparison data (diff between the two PCRs)
      `${apiEndpoint}diff/future/comparison/${firstRCP}/${secondRCP}/${apiParameter[0]}/${apiParameter[2]}/${apiParameter[4]}/${apiParameter[3]}`,

      // [6] reference table data
      `${apiEndpoint}cluster/current_${apiParameter[0]}/${apiParameter[4]}/1971/2000`,

      // [7-8] near future table data
      `${apiEndpoint}cluster/${firstRCP}_${apiParameter[0]}/${apiParameter[4]}/2035`,
      `${apiEndpoint}cluster/${secondRCP}_${apiParameter[0]}/${apiParameter[4]}/2035`,

      // [9-10] medium future table data
      `${apiEndpoint}cluster/${firstRCP}_${apiParameter[0]}/${apiParameter[4]}/2055`,
      `${apiEndpoint}cluster/${secondRCP}_${apiParameter[0]}/${apiParameter[4]}/2055`,

      // [11-12] far future table data
      `${apiEndpoint}cluster/${firstRCP}_${apiParameter[0]}/${apiParameter[4]}/${END_YEAR}`,
      `${apiEndpoint}cluster/${secondRCP}_${apiParameter[0]}/${apiParameter[4]}/${END_YEAR}`
    );

    files.forEach((url) => {
      promises.push(
        fetch(url, {
          method: 'get',
        })
          .then((response) => response.json())
          .then((response) => response)
      );
    });
    Promise.all(promises).then((values) => {
      const diffColors = values[0].colorsets.filter(
        (obj) => obj.var === apiParameter[0]
      );
      const comparisonColors = values[1].colorsets.filter(
        (obj) => obj.var === apiParameter[0]
      );
      if (diffColors.length === 0 || comparisonColors.length === 0) {
        console.log('No matching colorset found');
      }

      const avg = {};

      avg.value =
        values[6].reduce((sum, val) => sum + val.value, 0) / values[6].length;

      actuallyLoading = false;
      this.setState({
        isLoading: false,
        colorsets: diffColors,
        colorsetsComparison: comparisonColors,
        diffDataFirstMap: values[3],
        diffDataSecondMap: values[4],
        diffDataComparison: values[5],
        latLonData: values[2],
        tableCaption: `${rcpLables[firstRCP]} vs. ${rcpLables[secondRCP]}: ${chartTitle} für die Region ${regionName} im Vergleich zur Vergangenheit`,
        tableDataComparison: [
          [avg],
          values[7][0][apiParameter[2]],
          values[8][0][apiParameter[2]],
          values[9][0][apiParameter[2]],
          values[10][0][apiParameter[2]],
          values[11][0][apiParameter[2]],
          values[12][0][apiParameter[2]],
          diffColors[0].changeUnit,
          diffColors[0].absolutUnit,
          [rcpLables[firstRCP], rcpLables[secondRCP]],
          this.getAggregationLabel(apiParameter[2]),
        ],
        chartSubtitle: `${this.getRegionLabel(
          regionName,
          regionPartitioning
        )}, ${this.getAggregationLabel(apiParameter[2])}`,
      });
    });
  }

  getFutureTimeMaps() {
    const promises = [];
    const files = [colorSetsFutureURL, colorSetsFutureDiff, lonlatURL];
    this.setState({ isLoading: true });
    actuallyLoading = true;
    const {
      apiEndpoint,
      apiParameter,
      regionName,
      regionPartitioning,
      timeCharacteristic,
      selectedYear,
    } = this.props;

    const characteristic = timeCharacteristic.split('_')[0];
    const timeWindow = timeCharacteristic.split('_')[1];

    const timeWindowString = `${apiParameter[3] - 14} - ${
      parseInt(apiParameter[3], 10) + 15
    }`;

    files.push(
      // [3] time map data
      // `${apiEndpoint}shape/${firstRCP}_${apiParameter[0]}-${apiParameter[2]}/${apiParameter[4]}/${apiParameter[3]}`
      `${apiEndpoint}future/time_scenario/${timeWindow}/${characteristic}/${apiParameter[2]}/${apiParameter[4]}/${apiParameter[1]}/${apiParameter[3]}`
    );
    files.forEach((url) => {
      promises.push(
        fetch(url, {
          method: 'get',
        })
          .then((response) => response.json())
          .then((response) => response)
      );
    });
    Promise.all(promises).then((values) => {
      const diffColors = values[0].colorsets.filter(
        (obj) => obj.var === apiParameter[0]
      );
      const comparisonColors = values[1].colorsets.filter(
        (obj) => obj.var === apiParameter[0]
      );
      if (diffColors.length === 0 || comparisonColors.length === 0) {
        console.log('No matching colorset found');
      }
      colorsSetsTemp = values[0];
      actuallyLoading = false;
      this.setState({
        isLoading: false,
        colorsetsTimeMap: values[0].colorsets,
        colorsetsComparison: comparisonColors,
        dataTimeMaps: values[3],
        latLonData: values[2],
        chartSubtitle: `
        ${this.getRegionLabel(regionName, regionPartitioning)}, ${rcpLables[apiParameter[1]]}, ${this.getAggregationLabel(apiParameter[2])}, ${timeWindowString.replaceAll(' ', '\u00A0')}\u00A0zu\u00A01971\u00A0-\u00A02000
        `,
      });
    });
  }

  getFutureTimeGraph() {
    const promises = [];
    const files = [colorSetsFutureURL, lonlatURL];
    this.setState({ isLoading: true });
    actuallyLoading = true;
    const {
      apiEndpoint,
      apiParameter,
      calledRCP,
      regionName,
      regionPartitioning,
      selectedYear,
      timeCharacteristic,
    } = this.props;


    const characteristic = timeCharacteristic.split('_')[0];
    const timeWindow = timeCharacteristic.split('_')[1];

    files.push(
      `${apiEndpoint}future/time_scenario-cluster-adv/${timeWindow}/${characteristic}/${apiParameter[4]}/rcp26/${apiParameter[3]}`,
      `${apiEndpoint}future/time_scenario-cluster-adv/${timeWindow}/${characteristic}/${apiParameter[4]}/rcp45/${apiParameter[3]}`,
      `${apiEndpoint}future/time_scenario-cluster-adv/${timeWindow}/${characteristic}/${apiParameter[4]}/rcp85/${apiParameter[3]}`,
    );
    files.forEach((url) => {
      promises.push(
        fetch(url, {
          method: 'get',
        })
          .then((response) => response.json())
          .then((response) => response)
      );
    });
    Promise.all(promises).then((values) => {
      const useColors = values[0].colorsets.filter(
        (obj) => obj.var === apiParameter[0]
      );
      if (useColors.length === 0) {
        console.log('ERROR: No matching colorset found');
      }

      const graphData = [values[2].data, values[3].data, values[4].data];

      const timeWindowString = `${apiParameter[3] - 14} - ${
        parseInt(apiParameter[3], 10) + 15
      }`;

      actuallyLoading = false;
      this.setState({
        isLoading: false,
        colorsets: useColors,
        latLonData: values[1],
        graphDataTime: graphData,
        timeGraphLimits: values[2].limits,
        chartSubtitle: `
        ${this.getRegionLabel(
          regionName,
          regionPartitioning
        )}, ${timeWindowString.replaceAll(' ', '\u00A0')} zu 1971\u00A0-\u00A02000
        `,
      });
    });
  }

  getWarmingStripes() {
    this.setState({ isLoading: true });
    actuallyLoading = true;

    const promises = [];
    const dataSources = [];

    const { apiEndpoint, apiParameter, regionName, regionPartitioning } =
      this.props;

    dataSources.push(`${apiEndpoint}warming-stripes/${apiParameter[4]}`);

    dataSources.forEach((url) => {
      promises.push(
        fetch(url, {
          method: 'get',
        })
          .then((response) => response.json())
          .then((response) => response)
      );
    });

    Promise.all(promises).then((values) => {
      actuallyLoading = false;
      this.setState({
        isLoading: false,
        graphData: values[0],
        chartSubtitle: this.getRegionLabel(regionName, regionPartitioning),
      });
    });
  }

  render() {
    const {
      colorsets,
      colorsetsTimeMap,
      latLonData,
      isLoading,
      mapData,
      tableData,
      tableDataComparison,
      tableCaption,
      chartSubtitle,
      graphData,
      refPeriod,
      differenceMapToRefPeriod,
      selectedChangesAddedToRefperiod,
      diffDataFirstMap,
      diffDataSecondMap,
      diffDataComparison,
      colorsetsComparison,
      dataTimeMaps,
      graphDataTime,
      timeGraphLimits,
      mapDataYears,
    } = this.state;

    const {
      vistype,
      mode,
      calledVariable,
      calledComparisonRCP,
      chartTitle,
      activeRegion,
      filteredShape,
      fullShape,
      selectedYear,
      epoch,
      rcp,
      unit,
      children,
      apiParameter,
      timeCharacteristic,
      configString,
      usp,
      apiEndpoint,
    } = this.props;


    const dateString = getDateString();

    if (!isLoading && !actuallyLoading) {
      if (mode === 'warmingstripes') {
        return (
          <div className="datawrapper grid__bit -w9-tablet">
            {children()}
            {usp === 'view' && (
              <ExportButtons
                chartContainer={this.placeholderMap}
                configString={configString}
                apiUrl={apiEndpoint}
                useLegacyDownloader
              />
            )}
            <div className="download-container" ref={this.placeholderMap}>
              <Warmingstripesplot
                graphData={graphData}
                chartTitle="Warming Stripes"
                chartSubtitle={chartSubtitle}
              />
              {usp === 'pdf' && <div className="pdf-date"><p >Erstellt am: {dateString}</p></div>}
            </div>
          </div>
        );
      }

      switch (vistype) {
        case 'map':
          if (mode === 'standard') {
            return (
              <div
                className="datawrapper grid__bit -w9-tablet"
                ref={this.placeholderWrapper}
              >
                {children()}
                {usp === 'view' && (
                  <ExportButtons
                    chartContainer={this.placeholderMap}
                    configString={configString}
                    apiUrl={apiEndpoint}
                  />
                )}
                <div className="download-container" ref={this.placeholderMap}>
                  <MapChart
                    ref={this.placeholderMap}
                    filteredShape={filteredShape}
                    latLonData={latLonData}
                    mapData={mapData}
                    refPeriod={refPeriod}
                    colorsets={colorsets}
                    activeRegion={activeRegion}
                    chartTitle={chartTitle}
                    chartSubtitle={chartSubtitle}
                    fullShape={fullShape}
                    selectedYear={selectedYear}
                    epoch={epoch}
                    themesField={apiParameter}
                    differenceMapToRefPeriod={differenceMapToRefPeriod}
                    selectedChangesAddedToRefperiod={
                      selectedChangesAddedToRefperiod
                    }
                  />
                </div>
                <Table tableData={tableData} tableCaption={tableCaption} />
                {usp === 'pdf' && <div className="pdf-date"><p >Erstellt am: {dateString}</p></div>}
              </div>
            );
          }
          if (mode === 'scenarios') {
            const firstRCP = calledComparisonRCP.split('VS')[0];
            const secondRCP = calledComparisonRCP.split('VS')[1];
            return (
              <div
                className="datawrapper grid__bit -w9-tablet"
                ref={this.placeholderWrapper}
              >
                {children()}
                {usp === 'view' && (
                  <ExportButtons
                    chartContainer={this.placeholderMap}
                    configString={configString}
                    apiUrl={apiEndpoint}
                  />
                )}
                <div className="download-container" ref={this.placeholderMap}>
                  <MapChartComparison
                    firstRCP={firstRCP}
                    secondRCP={secondRCP}
                    dataFirstRCP={diffDataFirstMap}
                    dataSecondRCP={diffDataSecondMap}
                    dataComparison={diffDataComparison}
                    filteredShape={filteredShape}
                    latLonData={latLonData}
                    colorsets={colorsets}
                    colorsetsComparison={colorsetsComparison}
                    activeRegion={activeRegion}
                    chartTitle={chartTitle}
                    chartSubtitle={chartSubtitle}
                    fullShape={fullShape}
                    selectedYear={selectedYear}
                    epoch={epoch}
                    themesField={apiParameter}
                  />
                </div>
                <ComparisonTable
                  tableData={tableDataComparison}
                  tableCaption={tableCaption}
                />
                {usp === 'pdf' && <div className="pdf-date"><p >Erstellt am: {dateString}</p></div>}
              </div>
            );
          }
          if (mode === 'time') {
            let mapSize = 240;
            const timeWindow = timeCharacteristic.split('_')[1];
            if (timeWindow !== 'months') {
              mapSize = 280;
            }
            let shape = fullShape.features.find(
              (feature) => feature.properties.OBJECTID === activeRegion
            );
            shape = extractActiveShape(shape);

            const geoPathShape = buildGeoPath(shape, mapSize, mapSize, 10);
            return (
              <div className="datawrapper grid__bit -w9-tablet">
                {children()}
                {usp === 'view' && (
                  <ExportButtons
                    chartContainer={this.placeholderMap}
                    configString={configString}
                    apiUrl={apiEndpoint}
                  />
                )}
                <div className="download-container" ref={this.placeholderMap}>
                  <div className="charts-container">
                    <h3 className="chart-title">{chartTitle}</h3>
                    <h5 className="chart-subtitle">{chartSubtitle}</h5>
                    <TimeMap
                      size={mapSize}
                      colorsets={colorsetsTimeMap}
                      data={dataTimeMaps}
                      shape={shape}
                      shapePath={geoPathShape}
                      latLonData={latLonData}
                      caption={{firstLine: 'test', secondLine: ''}}
                      timeWindow={timeWindow}
                      timeCharacteristic={timeCharacteristic}
                      apiParameter={apiParameter}
                      freshData={freshData}
                      usp={usp}
                    />
                    {usp === 'pdf' && <div className="pdf-date"><p >Erstellt am: {dateString}</p></div>}
                  </div>
                </div>
              </div>
            );
          }

          if (mode === 'years') {
            const svgSize = 180;
            const colorConfigReference = generateColorConfig(
              'change',
              colorsets
            );
            let shape = fullShape.features.find(
              (feature) => feature.properties.OBJECTID === activeRegion
            );
            shape = extractActiveShape(shape);

            const geoPathShape = buildGeoPath(shape, svgSize, svgSize, 10);

            return (
              <div className="datawrapper grid__bit -w9-tablet">
                {children()}
                {usp === 'view' && (
                  <ExportButtons
                    chartContainer={this.placeholderMap}
                    configString={configString}
                    apiUrl={apiEndpoint}
                  />
                )}
                <div className="download-container" ref={this.placeholderMap}>
                  <div className="charts-container">
                    <h3 className="chart-title">{chartTitle}</h3>
                    <h5 className="chart-subtitle">{chartSubtitle}</h5>
                    <YearsMap
                      size={svgSize}
                      colorConfig={colorConfigReference}
                      data={mapDataYears}
                      shape={shape}
                      shapePath={geoPathShape}
                      latLonData={latLonData}
                      caption={{firstLine: 'test', secondLine: ''}}
                      timeWindow={timeCharacteristic.split('_')[1]}
                      apiParameter={apiParameter}
                      freshData={freshData}
                    />
                    {usp === 'pdf' && <div className="pdf-date"><p >Erstellt am: {dateString}</p></div>}
                  </div>
                </div>
              </div>
            );
          }

          break;

        case 'chart':
          if (mode === 'standard') {
            return (
              <div className="datawrapper grid__bit -w9-tablet">
                {children()}
                {usp === 'view' && (
                  <ExportButtons
                    chartContainer={this.placeholderMap}
                    configString={configString}
                    useLegacyDownloader
                    apiUrl={apiEndpoint}
                  />
                )}
                <div className="download-container" ref={this.placeholderMap}>
                  <Graph
                    graphData={graphData}
                    chartTitle={chartTitle}
                    chartSubtitle={chartSubtitle}
                    calledVariable={calledVariable}
                    colorsets={colorsets}
                    epoch={epoch}
                    rcp={rcp}
                    unit={unit}
                    pdfView={usp === 'pdf'}
                  />
                  {usp === 'pdf' && <div className="pdf-date"><p >Erstellt am: {dateString}</p></div>}
                </div>
                </div>

            );
          }
          if (mode === 'scenarios') {
            return (
              <div className="datawrapper grid__bit -w9-tablet">
                {children()}
                {usp === 'view' && (
                  <ExportButtons
                    chartContainer={this.placeholderMap}
                    configString={configString}
                    useLegacyDownloader
                    apiUrl={apiEndpoint}
                  />
                )}
                <div className="download-container" ref={this.placeholderMap}>
                  <Boxplot
                    graphData={graphData}
                    chartTitle={chartTitle}
                    chartSubtitle={chartSubtitle}
                    calledVariable={calledVariable}
                    colorsets={colorsets}
                    epoch={epoch}
                    rcp={rcp}
                    unit={unit}
                    pdfView={usp === 'pdf'}
                  />
                  {usp === 'pdf' && <div className="pdf-date"><p >Erstellt am: {dateString}</p></div>}
                </div>
              </div>
            );
          }

          if (mode === 'time') {
            return (
              <div className="datawrapper grid__bit -w9-tablet">
                {children()}
                {usp === 'view' && (
                  <ExportButtons
                    chartContainer={this.placeholderMap}
                    configString={configString}
                    useLegacyDownloader
                    apiUrl={apiEndpoint}
                  />
                )}
                <div className="download-container" ref={this.placeholderMap}>
                  <TimeGraph
                    graphData={graphDataTime}
                    limits={timeGraphLimits}
                    chartTitle={chartTitle}
                    chartSubtitle={chartSubtitle}
                    calledVariable={calledVariable}
                    colorsets={colorsets}
                    epoch={epoch}
                    rcp={rcp}
                    unit={unit}
                    timeWindow={timeCharacteristic.split('_')[1]}
                    pdfView={usp === 'pdf'}
                  />
                  {usp === 'pdf' && <div className="pdf-date"><p >Erstellt am: {dateString}</p></div>}
                </div>
              </div>
            );
          }
          break;

        default:
          return null;
      }
    } else {
      return (
        <div className="datawrapper grid__bit -w9-tablet">
          {children(true)}
          <Loader
            type="Bars"
            color={colors.themeBase.accent}
            height={100}
            width={100}
            className="isLoading"
          />
        </div>
      );
    }
  }

  getRegionLabel(regionName, regionPartitioning) {
    if (['Alpen', 'Alpenvorland'].includes(regionName)) {
      return `${regionName} (${regionPartitioning})`;
    }

    return regionName;
  }

  getAggregationLabel(aggregation) {
    switch (aggregation) {
      case 'min':
        return 'Minimum';
      case 'median':
        return 'Median';
      case 'max':
        return 'Maximum';
    }
  }
}

Datawrapper.propTypes = {
  vistype: PropTypes.string,
  filteredShape: PropTypes.array,
  fullShape: PropTypes.object,
  activeRegion: PropTypes.number,
  calledRCP: PropTypes.string,
  rcp: PropTypes.shape({
    viewIsActive: PropTypes.bool.isRequired,
    selectedItems: PropTypes.array.isRequired,
  }).isRequired,
  regionName: PropTypes.string,
  apiEndpoint: PropTypes.string,
  calledVariable: PropTypes.string,
  apiParameter: PropTypes.array,
  chartTitle: PropTypes.string,
  unit: PropTypes.string,
  epoch: PropTypes.string,
  children: PropTypes.func.isRequired,
  selectedYear: PropTypes.string,
  timeCharacteristic: PropTypes.string,
  configString: PropTypes.string,
  usp: PropTypes.string,
};

Datawrapper.defaultProps = {
  vistype: '',
  apiEndpoint: '',
  selectedYear: '',
  calledVariable: '',
  calledRCP: '',
  regionName: '',
  filteredShape: [],
  apiParameter: [],
  chartTitle: '',
  unit: '',
  epoch: '',
  fullShape: {},
  activeRegion: 11,
  timeCharacteristic: 'tas-months',
  configString: '',
  usp: '',
};

export default Datawrapper;
